export const IMAGE_FORMATS = ['png', 'jpg', 'jpeg'];
export const APPLICATION_FORMATS = ['png', 'jpg', 'jpeg', 'pdf', 'webp'];
